import LookupGroupType, { LookupType } from '../../models/lookup';
import axiosInstance from '../../utils/http-client';

export const getLookup = (slug: string, lookupName: string, lang: string): Promise<LookupType> => {
  return axiosInstance.get(`/api/v1/client/${slug}/lookup?lookupName=${lookupName}&lang=${lang}`, {});
};

export const getGroupLookup = (slug: string, lookupName: string, lang: string): Promise<LookupGroupType> => {
  return axiosInstance.get(`/api/v1/client/${slug}/grouplookup?lookupName=${lookupName}&lang=${lang}`, {});
};

export const getAppLookup = (lookupName: string, lang: string): Promise<LookupType> => {
  return axiosInstance.get(`/api/v1/app/lookup?lookupName=${lookupName}&lang=${lang}`, {});
};
